export const organizationConstants = {
    NO_ORGANIZATION_ALERT: 'NO_ORGANIZATION_ALERT',
    CREATE_ORGANIZATION_SUCCESS: 'CREATE_ORGANIZATION_SUCCESS',
    REMOVE_MESSAGE_BLOCK: 'REMOVE_MESSAGE_BLOCK'
};
